<template lang="pug">
  el-amap(
    v-if="isData"
    class="amap-demo"
    vid="amap"
    :zoom="zoom"
    :center="center"
    :height="300")
    div(
      v-for="(markerItem, i) in markerList"
      :key="i")
      el-amap-marker(
        v-for="(marker, j) in markerItem"
        :key="j"
        :title="marker.title"
        :position="marker.position"
        :events="marker.events"
        :visible="marker.visible"
        :draggable="marker.draggable")
        //- :editable="markerItem.editable"
      el-amap-polyline(
        :path="markerItem | filterPath"
        :strokeColor="markerItem[0].strokeColor"
        )
    el-amap-info-window(
      v-if="isShowMessage"
      ref="windowsPage"
      :isCustom="true"
      :position="windowsPage.position"
      :content="windowsPage.content"
      :visible="windowsPage.visible"
      :offset="windowsPage.offset"
      :showShadow="true"
      :events="windowsPage.events"
      :closeWhenClickMap="true")
</template>

<script>
/**
 * @name mapsPage 组件
 * @author 黄丰瑞 <huangfr@gddit.com>
 * @description 通过与后台预定的接口格式以及可配置地图资源数组定义直接出地图
 */
import { fetch } from '@/utils/api'
import { expire } from '@/utils/auth'

export default {
  name: 'mapsPage',
  created () {
    this.getData()
  },
  props: {
    center: { // 地图中心点（必填）
      type: Array,
      default: () => []
    },
    zoom: { // 地图缩放级别（必填）
      type: Number,
      default: 12
    },
    markers: { // 标点配置（必填）
      type: Object,
      default: () => ({})
    },
    resource: { // 接口名（必填）
      type: String,
      default: null
    },
    columns: { // 字段配置
      type: Object,
      default: () => ({})
    }
  },
  filters: {
    filterPath (path) {
      const pathList = path.map(item => {
        return item.position
      })
      return pathList
    }
  },
  data () {
    return {
      isShowMessage: false,
      colorList: ['#409EFF', '#67C23A', '#EB9E05', '#FA5555'],
      isData: false,
      windowsPage: {},
      markerList: []
      // markerList: [{
      //   position: [121.5389385, 31.21515044],
      //   events: {
      //     click: (a) => {
      //       console.log(a)
      //     },
      //     dragend: (e) => {
      //       this.markerList[0].position = [e.lnglat.lng, e.lnglat.lat]
      //     }
      //   },
      //   title: '',
      //   visible: true,
      //   draggable: false,
      //   animation: 'AMAP_ANIMATION_BOUNCE',
      //   template: '<span>1</span>'
      // }]
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  methods: {
    getData () {
      this.isData = true
      fetch({
        method: 'get',
        url: this.resource
      })
      .then(data => {
        this.isData = true
        if (data) {
          this.getMaters(data)
        }
      })
    },
    getInfoData (data, infoList) {
      console.log(data)
      return infoList.map(info => {
        return {
          label: this.columns[info].label,
          value: data[info]
        }
      })
    },
    getMaters (data) {
      // const data = [{
      //   id: 1,
      //   name: '抄表员1',
      //   data: [{
      //     type: 'WATER_USER', // 行走点 or 抄表点
      //     lonlot: [121.5389385, 31.21515044],
      //     createTime: 159135574000,
      //     data: {
      //       name: 'aaaaaa',
      //       message: 'bbbbb'
      //     }
      //   }, {
      //     type: 'WATER_USER', // 行走点 or 抄表点
      //     lonlot: [121.5389385, 31.29615044],
      //     createTime: 159135574000,
      //     data: {
      //       name: 'aaaaaa',
      //       message: 'bbbbb'
      //     }
      //   }, {
      //     type: 'reading', // 行走点 or 抄表点
      //     lonlot: [121.5273285, 31.21515044],
      //     createTime: 159135574000,
      //     data: {
      //       name: 'aaaaaa',
      //       message: 'bbbbb'
      //     }
      //   }]
      // }, {
      //   id: 2,
      //   name: '抄表员2',
      //   data: [{
      //     type: 'WATER_USER', // 行走点 or 抄表点
      //     lonlot: [121.5366666, 31.21515044],
      //     createTime: 159135574000,
      //     data: {
      //       name: '抄表员aaaaaa',
      //       message: '抄表员bbbbbb'
      //     }
      //   }, {
      //     type: 'reading', // 行走点 or 抄表点
      //     lonlot: [121.5399999, 31.29615044],
      //     createTime: 159135574000,
      //     data: {
      //       name: '抄表员aaaaaa',
      //       message: '抄表员bbbbbb'
      //     }
      //   }]
      // }]
      // console.log(data)
      const filterData = data.filter(filterItem => {
        return filterItem.data.map(filterMarkItem => {
          return filterMarkItem.lonlot.length
        })[0]
      })
      this.markerList = filterData.map((item, index) => {
        return item.data.map(markItem => {
          const markerType = this.markers[markItem.type]
          const infoList = this.getInfoData(markItem.data, markerType.infoList)
          return {
            strokeColor: this.colorList[index],
            position: markItem.lonlot,
            events: {
              click: (a) => {
                const _this = this
                this.isShowMessage = true
                this.windowsPage = {
                  position: markItem.lonlot,
                  content: `<div
                    style="max-width:400px;
                    border:1px solid #ddd;
                    padding:10px 10px 0 10px;
                    background:rgba(0,0,0,0.5);
                    color: #fff;">
                  ${
                    this.showInfoData(infoList)
                  }
                  </div>`,
                  offset: [90, -20],
                  visible: true,
                  events: {
                    close () {
                      _this.isShowMessage = false
                    }
                  }
                }
                // const isOpen = this.$refs.windowsPage.$$getInstance().open()
                // console.log(isOpen)
                // this.$nextTick(() => {
                //   console.log()
                // })
              }
            },
            title: item.name,
            visible: true
          }
        })
      })
      // this.markerList = data.map(item => {
      //   return {
      //     position: [item.longitude, item.latitude],
      //     events: {
      //       click: (a) => {
      //         console.log(a)
      //       }
      //     },
      //     title: item.userName,
      //     visible: true
      //   }
      // })
    },
    showInfoData (infoList) {
      let data = ''
      infoList.forEach((info, key) => {
        data += `<p>${info.label}：${info.value}</p>`
      })
      return data
    },
    getWindows (data) {
      this.windows = data.map(item => {
        return {
          position: [item.longitude, item.latitude],
          // content: '抄表员：' + item.UserName,
          content: '抄表员：' + String(item.userId),
          visible: true,
          events: {
            close () {
              console.log('close infowindow')
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="sass">
  .amap-demo
    height: 450px
</style>


// WEBPACK FOOTER //
// index.vue?7949fbea